export default {
  getActivityDetail: '/gateway/capp/ActivityForAppRpcService/detail',
  getRankList: '/gateway/capp/ActivityForAppRpcService/queryRankList',
  getBonus: '/courier/api/h5/v2/reward/getBonus',
  queryForAppDetail: '/gateway'
}
